import { createApi } from '@reduxjs/toolkit/query/react';
import { customHandoverBaseQuery } from '../customBaseQuery';
import { IncomingView, IncomingViewResponse } from '../../features/incomingView/types';

export const incomingViewApi = createApi({
  reducerPath: 'incomingViewApi',
  baseQuery: customHandoverBaseQuery,
  tagTypes: ['IncomingView', 'IncomingViewList'],
  refetchOnMountOrArgChange: 30,
  refetchOnReconnect: true,
  endpoints: builder => ({
    createIncomingView: builder.mutation<
      { message: string; viewId: string; viewToken?: string; viewLink?: string },
      { departureId: string; incomingEmployeeEmail: string; frontendUrl?: string }
    >({
      query: body => ({ url: '/incoming-view', method: 'post', body }),
      invalidatesTags: ['IncomingViewList'],
    }),

    getMyIncomingView: builder.query<IncomingViewResponse, void>({
      query: () => ({ url: '/incoming-view/my', method: 'get' }),
      providesTags: ['IncomingView'],
    }),

    getAllIncomingViews: builder.query<IncomingView[], void>({
      query: () => ({ url: '/incoming-view/all', method: 'get' }),
      transformResponse: (res: { views: IncomingView[] }) => res.views ?? [],
      providesTags: ['IncomingViewList'],
    }),

    getIncomingViewById: builder.query<
      IncomingViewResponse,
      { viewId: string; token?: string }
    >({
      query: ({ viewId, token }) => ({
        url: token ? `/incoming-view/${viewId}?t=${token}` : `/incoming-view/${viewId}`,
        method: 'get',
      }),
      providesTags: (_, __, { viewId }) => [{ type: 'IncomingView', id: viewId }],
    }),

    acknowledgeItem: builder.mutation<
      { message: string },
      { viewId: string; itemId: string; token?: string }
    >({
      query: ({ viewId, itemId, token }) => ({
        url: token ? `/incoming-view/${viewId}/acknowledge?t=${token}` : `/incoming-view/${viewId}/acknowledge`,
        method: 'put',
        body: { itemId },
      }),
      invalidatesTags: (_, __, { viewId }) => [
        { type: 'IncomingView', id: viewId },
        'IncomingView',
        'IncomingViewList',
      ],
    }),
  }),
});

export const {
  useCreateIncomingViewMutation,
  useGetMyIncomingViewQuery,
  useGetAllIncomingViewsQuery,
  useGetIncomingViewByIdQuery,
  useAcknowledgeItemMutation,
} = incomingViewApi;
